import { render } from "./addAssessmentTasksModal.vue?vue&type=template&id=17acf4c2&scoped=true"
import script from "./addAssessmentTasksModal.vue?vue&type=script&lang=js"
export * from "./addAssessmentTasksModal.vue?vue&type=script&lang=js"

import "./addAssessmentTasksModal.vue?vue&type=style&index=0&id=17acf4c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17acf4c2"]])

export default __exports__